var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('CTRLACS-APP-03'))?_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$router.push({ name: 'Aplicacoes_Atualizar' })}}},[_c('span',[_c('i',{staticClass:"fa fa-edit mr-2"}),_vm._v(" Atualizar")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }